import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconLink: React.FC<IconProps> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.0303 3H12.5177C12.736 3 12.913 3.177 12.913 3.39535V5.63568M9.591 6.07495L12.2267 3.68633"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M7.83954 3H3.26144C3.10457 3 2.99999 3.09955 2.99999 3.24887V12.7511C2.99999 12.9005 3.10457 13 3.26144 13H12.6736C12.8305 13 12.9351 12.9005 12.9351 12.7511V8.21375"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
